import Safety from './Safety'

export default Safety
